import { HANDLE_SUBSCRIPTION, SET_SHARE_SCREEN_BTN } from '../actions/types';

const initialState = {
	isStreamSubscribed: false,
	connectionCount: 0,
	loading: true,
	disabledShareScreenBtn: false
};

export default function (state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case HANDLE_SUBSCRIPTION:
			return {
				...state,
				isStreamSubscribed: payload,
				connectionCount: payload + 1,
				loading: false,
			};

		case SET_SHARE_SCREEN_BTN:
			return {
				...state,
				disabledShareScreenBtn: payload
			};
		default:
			return state;
	}
}
